import siteTheme from './siteTheme';

const siteBaseTheme = {
    base: {
        colors: {
            light: '#f1f1f1',
            dark: '#323232',
            primary: '#138496',
            info: '#0069d9',
        },
        body: {
            background: siteTheme.lightMode.site.stage.backgroundColor,
        },
    },
};

export default siteBaseTheme;
